import {
  BestBuyLogo,
  BodyLinkV3,
  ButtonV3,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

const VisitBestBuy = (): JSX.Element => {
  const t = useTranslations();
  return (
    <LayoutGrid className="my-24" data-cy="best-buy-purchase">
      <div className="col-main lg:col-end-11">
        <BestBuyLogo height={36} className="-mt-10" />
        <TypographyV3 variant="h4" Element="h2" height="tight" className="mb-6">
          {t.rich('sizing_bestbuy_sizing_kit_title', {
            sup: (chunks) => (
              <sup className="align-super text-sm">{chunks}</sup>
            ),
          })}
        </TypographyV3>
      </div>

      <div className="col-main lg:col-start-13">
        <TypographyV3 variant="body-large" className="max-w-lg">
          {t.rich('sizing_bestbuy_sizing_kit_text', {
            bestbuyLink(chunks: ReactNode) {
              return (
                <BodyLinkV3
                  external
                  className="text-sandstone-500"
                  href="https://www.bestbuy.com/site/searchpage.jsp?_dyncharset=UTF-8&browsedCategory=pcmcat1481858086983&id=pcat17071&iht=n&ks=960&list=y&qp=brand_facet%3DBrand~Oura&sc=Global&st=categoryid%24pcmcat1481858086983&type=page&usc=All%20Categories"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {chunks}
                </BodyLinkV3>
              );
            },
          })}
        </TypographyV3>
        <ButtonV3
          external
          className="mt-6"
          variant="secondary-dark"
          href="https://www.bestbuy.com/site/searchpage.jsp?_dyncharset=UTF-8&browsedCategory=pcmcat1481858086983&id=pcat17071&iht=n&ks=960&list=y&qp=brand_facet%3DBrand~Oura&sc=Global&st=categoryid%24pcmcat1481858086983&type=page&usc=All%20Categories"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('sizing_bestbuy_sizing_kit_button')}
        </ButtonV3>
      </div>
    </LayoutGrid>
  );
};

export default VisitBestBuy;
